<div class="kalici-olcumler-container">
  <!-- Başlık -->
  <div class="dialog-header">
    <div class="header-left">
      <img src="./simgeler/coklu-cetvel.png" class="header-icon" alt="Ölçümler">
      <span class="header-title">Kalıcı Ölçümler</span>
      <span class="header-count">({{ olcumListesi.length }} adet)</span>
    </div>
  </div>

  <!-- Araç Çubuğu -->
  <div class="toolbar">
    <!-- Arama -->
    <div class="search-box">
      <i class="icon search"></i>
      <input type="text"
             [(ngModel)]="aramaMetni"
             placeholder="Ölçüm ara..."
             class="search-input">
      <i class="icon close link"
         *ngIf="aramaMetni"
         (click)="aramaMetni = ''"></i>
    </div>

    <!-- Sıralama -->
    <div class="sort-buttons">
      <button class="ui mini icon button"
              [class.active]="siralama === 'tarih'"
              (click)="siralamaDeistir('tarih')"
              title="Tarihe Göre Sırala">
        <i class="icon clock"></i>
        <i class="icon" [class.arrow-up]="siralama === 'tarih' && siralamaYonu === 'asc'"
                        [class.arrow-down]="siralama === 'tarih' && siralamaYonu === 'desc'"
                        *ngIf="siralama === 'tarih'"></i>
      </button>
      <button class="ui mini icon button"
              [class.active]="siralama === 'isim'"
              (click)="siralamaDeistir('isim')"
              title="İsme Göre Sırala">
        <i class="icon font"></i>
        <i class="icon" [class.arrow-up]="siralama === 'isim' && siralamaYonu === 'asc'"
                        [class.arrow-down]="siralama === 'isim' && siralamaYonu === 'desc'"
                        *ngIf="siralama === 'isim'"></i>
      </button>
      <button class="ui mini icon button"
              [class.active]="siralama === 'deger'"
              (click)="siralamaDeistir('deger')"
              title="Değere Göre Sırala">
        <i class="icon sort numeric down"></i>
        <i class="icon" [class.arrow-up]="siralama === 'deger' && siralamaYonu === 'asc'"
                        [class.arrow-down]="siralama === 'deger' && siralamaYonu === 'desc'"
                        *ngIf="siralama === 'deger'"></i>
      </button>
    </div>

    <!-- Toplu İşlemler -->
    <div class="bulk-actions">
      <button class="ui mini button"
              (click)="tumunuSec()"
              [title]="seciliOlcumler.size === filtrelenmisListe.length ? 'Seçimi Kaldır' : 'Tümünü Seç'">
        <i class="icon" [class.check-square]="seciliOlcumler.size === filtrelenmisListe.length"
                        [class.square-outline]="seciliOlcumler.size !== filtrelenmisListe.length"></i>
        {{ seciliOlcumler.size === filtrelenmisListe.length ? 'Seçimi Kaldır' : 'Tümünü Seç' }}
      </button>

      <button class="ui mini red button"
              [disabled]="seciliOlcumler.size === 0"
              (click)="secilileriSil()"
              title="Seçilenleri Sil">
        <i class="icon trash"></i>
        Sil ({{ seciliOlcumler.size }})
      </button>

      <button class="ui mini button"
              [disabled]="olcumListesi.length === 0"
              (click)="disariAktar()"
              title="Ölçümleri CSV olarak dışa aktar">
        <i class="icon download"></i>
        CSV
      </button>
    </div>
  </div>

  <!-- Ölçüm Listesi -->
  <div class="olcum-listesi" *ngIf="filtrelenmisListe.length > 0">
    <div class="olcum-item"
         *ngFor="let item of filtrelenmisListe"
         [class.selected]="seciliOlcumler.has(item.uuid)"
         [class.gizli]="!item.gorunur">

      <!-- Seçim Checkbox -->
      <div class="item-checkbox" (click)="secimToggle(item.uuid)">
        <i class="icon" [class.check-square]="seciliOlcumler.has(item.uuid)"
                        [class.square-outline]="!seciliOlcumler.has(item.uuid)"></i>
      </div>

      <!-- Renk Picker -->
      <div class="item-color">
        <input type="color"
               [value]="item.renk"
               (change)="renkDegistir(item, $event)"
               title="Renk Değiştir">
      </div>

      <!-- Ölçüm Bilgisi -->
      <div class="item-info" (dblclick)="olcumuOdakla(item)">
        <div class="item-baslik">{{ item.baslik }}</div>
        <div class="item-detay">
          <span class="item-isim">{{ item.isim }}</span>
          <span class="item-tarih">{{ tarihFormatla(item.tarih) }}</span>
        </div>
      </div>

      <!-- Aksiyon Butonları -->
      <div class="item-actions">
        <!-- Görünürlük -->
        <button class="ui mini icon button"
                (click)="gorunurlukToggle(item)"
                [title]="item.gorunur ? 'Gizle' : 'Göster'">
          <i class="icon" [class.eye]="item.gorunur" [class.eye-slash]="!item.gorunur"></i>
        </button>

        <!-- Odakla -->
        <button class="ui mini icon button"
                (click)="olcumuOdakla(item)"
                title="3D'de Odakla">
          <i class="icon crosshairs"></i>
        </button>

        <!-- Sil -->
        <button class="ui mini icon red button"
                (click)="olcumSil(item)"
                title="Sil">
          <i class="icon trash"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Boş Liste Mesajı -->
  <div class="empty-state" *ngIf="filtrelenmisListe.length === 0">
    <i class="icon ruler huge"></i>
    <div class="empty-text" *ngIf="olcumListesi.length === 0">
      Henüz kalıcı ölçüm yok.<br>
      Ölçüm aracından "Ölçüm Kalıcı Olsun" butonuna tıklayarak ölçüm ekleyebilirsiniz.
    </div>
    <div class="empty-text" *ngIf="olcumListesi.length > 0 && aramaMetni">
      "{{ aramaMetni }}" için sonuç bulunamadı.
    </div>
  </div>

  <!-- Alt Butonlar -->
  <div class="dialog-footer">
    <button class="ui mini button"
            (click)="olcumleriYukle()"
            title="Listeyi Yenile">
      <i class="icon refresh"></i>
      Yenile
    </button>

    <button class="ui mini red button"
            [disabled]="olcumListesi.length === 0"
            (click)="tumunuSil()"
            title="Tüm Ölçümleri Sil">
      <i class="icon trash"></i>
      Tümünü Sil
    </button>
  </div>
</div>
